import React from 'react';
import PropTypes from 'prop-types';

import { container } from './recipe-search-list.module.scss';

import RecipeSearchItem from '../../atoms/recipe/recipe-search-item';

const RecipeSearchList = ({ className = '', recipes, onRecipeSelect, selectedId }) => {
    return (
        <div className={`${container} ${className}`}>
            {recipes.map((recipe) => {
                return (
                    <div key={`recipe-search-item-${recipe.id}`}>
                        <RecipeSearchItem
                            key={`recipe-search-item-${recipe.id}`}
                            recipe={recipe}
                            onRecipeSelect={onRecipeSelect}
                            isSelected={selectedId != null && recipe.id === selectedId}
                        />
                    </div>
                );
            })}
        </div>
    );
};

RecipeSearchList.propTypes = {
    className: PropTypes.string,
    recipes: PropTypes.array,
    onRecipeSelect: PropTypes.func,
    selectedId: PropTypes.number,
};

RecipeSearchList.defaultProps = {
    className: '',
    recipes: [],
};

export default RecipeSearchList;
